import type {MilestonePickerMilestone} from '@github-ui/item-picker-milestone'
import {MilestoneIcon} from '@primer/octicons-react'
import {Link, Truncate} from '@primer/react'
import {clsx} from 'clsx'

import styles from './MilestoneMetadata.module.css'

export const MilestoneMetadata = ({milestone}: {milestone: MilestonePickerMilestone}) => {
  return (
    <Link href={milestone.url} aria-label={milestone.title} muted className={styles.milestoneLink}>
      <MilestoneIcon size={16} />
      <Truncate title={milestone.title} className={clsx(styles.milestoneTitle, styles.truncatedText)}>
        {milestone.title}
      </Truncate>
    </Link>
  )
}
